import React, { ReactElement, CSSProperties } from 'react';
import { GMGenericButton } from '../../ButtonBase/index';
import css from './FilterButtons.module.scss';

interface IFilterButtonsProps {
    children?: ReactElement<IFilterButtonProps> | Array<ReactElement<IFilterButtonProps> | undefined | false>;
}

export const FilterButtons = React.memo<IFilterButtonsProps>((props) => <div className={css.filterButtons}>{props.children}</div>);

interface IFilterButtonProps {
    onClick: () => void;
    color: string;
    children?: any;
    selected?: boolean;
    ariaLabel: string;
}

export const FilterButton = React.memo<IFilterButtonProps>((props) => {
    const style: CSSProperties = {
        border: '3px solid ' + props.color,
        backgroundColor: props.selected ? props.color : 'inherit',
        color: props.selected ? '#fff' : '#000',
    };

    return (
        <div className={css.filterButtonWrapper}>
            <GMGenericButton
                onClick={props.onClick}
                id={props.ariaLabel}
                ariaLabel={props.ariaLabel}
            >
                <div className={css.filterButton} style={style}>
                    {props.children}
                </div>
            </GMGenericButton>
        </div>
    );
});
